exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-blur[data-v-2c8f6ec3]{-webkit-backdrop-filter:blur(10.5px);backdrop-filter:blur(10.5px)}.wrapper-form[data-v-2c8f6ec3]{max-width:80%}@media screen and (min-width:540px){.wrapper-form[data-v-2c8f6ec3]{max-width:60%}}@media screen and (min-width:768px){.wrapper-form[data-v-2c8f6ec3]{max-width:826px}}.bg-white[data-v-2c8f6ec3]{background-color:#fff!important}.form-grid>.col[data-v-2c8f6ec3],.form-grid>[class*=col-][data-v-2c8f6ec3]{padding-right:8px;padding-left:8px}", ""]);

// exports
